/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Image, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// UI local components
import { Button, Text } from '@components/v2/ui';

// Styles
import classes from './FooterInfo.module.css';

// Images
import InukLogo from '@assets/images/inuk-logo.svg';

// Tabler icons
import { INUK_URL } from '@config/constants/common';
import { IconBrandTelegram } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const FooterInfo = ({
	contactUsUrl,
}: {
	contactUsUrl: string;
}) => {
	/* ******************************** HOOKS ******************************* */
	const { t } = useTranslation();

	/* ******************************** HELPERS ******************************* */
	const handleContactUs = () => {
		window.open(contactUsUrl, '_blank');
	};

	const handleLinkToInuk = () => {
		window.open(INUK_URL, '_blank');
	};

	/* ******************************** RENDERING ******************************* */
	return (
		<Stack gap="0px" align="center">
			<Text
				mt={'48px'}
				ta="center"
				c={'var(--mantine-color-igluSecondary-9)'}
				variant="caption"
			>
				{t('global.forMoreInformation')}
			</Text>
			<Image
				mt={'12px'}
				className={classes.logoInuk}
				src={InukLogo}
				fit="contain"
				onClick={handleLinkToInuk}
			/>
			<Button
				onClick={handleContactUs}
				mt={'24px'}
				variant={'outline'}
				rightSection={
					<IconBrandTelegram
						size={'24px'}
						stroke={'1.5px'}
					/>
				}
			>
				{t('global.contactUs')}
			</Button>
		</Stack>
	);
};
